/**
 * ESummaryTitle - Section title keys for summary component
 * Ported from IremboGov 2.0 DataService
 */
export enum ESummaryTitle {
  REQUESTER_DETAILS = 'REQUESTER_DETAILS',
  SUPPORTING_DOCUMENTS = 'SUPPORTING_DOCUMENTS',
  COLLECTION_OFFICE = 'COLLECTION_OFFICE',
  CHILD_DETAILS = 'CHILD_DETAILS',
  SPOUSE_DETAILS = 'SPOUSE_DETAILS',
  CHILD_FATHER_DETAILS = 'CHILD_FATHER_DETAILS',
  CHILD_MOTHER_DETAILS = 'CHILD_MOTHER_DETAILS',
  HEAD_OF_THE_FAMILY_DETAILS = 'HEAD_OF_THE_FAMILY_DETAILS',
  WITNESS_DETAILS = 'WITNESS_DETAILS',
  FATHER_DETAILS = 'FATHER_DETAILS',
  MOTHER_DETAILS = 'MOTHER_DETAILS',
  BIRTH_DETAILS = 'BIRTH_DETAILS',
  PARTNER_DETAILS = 'PARTNER_DETAILS',
  LEGAL_MARRIAGE_DETAILS = 'LEGAL_MARRIAGE_DETAILS',
  DECEASED_DETAILS = 'DECEASED_DETAILS',
  DEATH_DETAILS = 'DEATH_DETAILS',
  DECEASED_FATHER_DETAILS = 'DECEASED_FATHER_DETAILS',
  DECEASED_MOTHER_DETAILS = 'DECEASED_MOTHER_DETAILS',
  COURT_DETAILS = 'COURT_DETAILS',
  OCCUPATION_DETAILS = 'OCCUPATION_DETAILS',
  CHAIRPERSON_DETAILS = 'CHAIRPERSON_DETAILS',
  GUARDIANSHIP_AND_WILL_DETAILS = 'GUARDIANSHIP_AND_WILL_DETAILS',
  NATIONAL_ID_ISSUANCE_DETAILS = 'NATIONAL_ID_ISSUANCE_DETAILS',
  RELIGIOUS_MARRIAGE_DETAILS = 'RELIGIOUS_MARRIAGE_DETAILS',
  REPRESENTATIVE_DETAILS = 'REPRESENTATIVE_DETAILS',
  APPLICANT_DETAILS = 'APPLICANT_DETAILS',
  FAMILY_MEMBER_DETAILS = 'FAMILY_MEMBER_DETAILS',
  SUMMARY_DETAILS = 'SUMMARY_DETAILS',
  OTHER_DETAILS = 'OTHER_DETAILS',
  DOCUMENT_DETAILS = 'DOCUMENT_DETAILS',
  APPROVING_OFFICE_DETAILS = 'APPROVING_OFFICE_DETAILS',
  RECEIVER_DETAILS = 'RECEIVER_DETAILS',
  PARCEL_DETAILS = 'PARCEL_DETAILS',
  TRANSFER_DETAILS = 'TRANSFER_DETAILS',
  LAND_OWNER = 'LAND_OWNER',
  LAND_DETAILS = 'LAND_DETAILS',
  GAZETTE_DETAILS = 'GAZETTE_DETAILS',
  TICKET_DETAILS = 'TICKET_DETAILS',
  TEST_DETAILS = 'TEST_DETAILS',
  APPLICATION_DETAILS = 'APPLICATION_DETAILS',
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  APPOINTMENT_DETAILS = 'APPOINTMENT_DETAILS',
  RESIDENCE = 'RESIDENCE',
  QUALIFICATION_DETAILS = 'QUALIFICATION_DETAILS',
  OFFICE_DETAILS = 'OFFICE_DETAILS',
  INSURANCE_DETAILS = 'INSURANCE_DETAILS',
  VACCINATION_DETAILS = 'VACCINATION_DETAILS',
  HOUSE_HOLD_MEMBERS = 'HOUSE_HOLD_MEMBERS',
  REQUEST_DETAILS = 'REQUEST_DETAILS',
  GUARDIAN_DETAILS = 'GUARDIAN_DETAILS',
  VISIT_DETAILS = 'VISIT_DETAILS',
  VISA_DETAILS = 'VISA_DETAILS',
  ORGANISATION_DETAILS = 'ORGANISATION_DETAILS',
  AUTHORIZATION_DETAILS = 'AUTHORIZATION_DETAILS',
  LICENSE_DETAILS = 'LICENSE_DETAILS',
  MARRIAGE_DETAILS = 'MARRIAGE_DETAILS',
  DIVORCE_DETAILS = 'DIVORCE_DETAILS',
  ADOPTIVE_PARENT_DETAILS = 'ADOPTIVE_PARENT_DETAILS',
  BIOLOGICAL_PARENT_DETAILS = 'BIOLOGICAL_PARENT_DETAILS',
  ADOPTION_DETAILS = 'ADOPTION_DETAILS',
  WITNESS_DETAILS_COMBINED = 'WITNESS_DETAILS_COMBINED',
  PROJECT_DETAILS = 'PROJECT_DETAILS',
  BUSINESS_DETAILS = 'BUSINESS_DETAILS',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  HEALTH_FACILITY_DETAILS = 'HEALTH_FACILITY_DETAILS',
  INVESTIGATION_DETAILS = 'INVESTIGATION_DETAILS',
  FEDERATION_DETAILS = 'FEDERATION_DETAILS',
  EVENT_DETAILS = 'EVENT_DETAILS',
  VEHICLE_DETAILS = 'VEHICLE_DETAILS',
  REPRESENTATIVE_AND_WITNESSES_DETAILS = 'REPRESENTATIVE_AND_WITNESSES_DETAILS',
  REPETITIVE_DETAILS = 'REPETITIVE_DETAILS',
  SELLER_DETAILS = 'SELLER_DETAILS',
  BUYER_DETAILS = 'BUYER_DETAILS',
  LAND_AND_SALE = 'LAND_AND_SALE',
}

export enum ELocationTitle {
  PROVINCE = 'PROVINCE',
  DISTRICT = 'DISTRICT',
  SECTOR = 'SECTOR',
  CELL = 'CELL',
  VILLAGE = 'VILLAGE',
  COUNTRY = 'COUNTRY',
  CITY = 'CITY',
  PLACE_OF_PROCESSING_EMBEDDED = 'PLACE_OF_PROCESSING_EMBEDDED',
}
